import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import MfaSetup from '../views/MfaSetup.vue';
import MfaVerify from '../views/MfaVerify.vue';
import Memberships from '../views/Memberships.vue';
import MyDownloads from '../views/MyDownloads.vue';
import Payments from '../views/Payments.vue';
import Pets from '../views/Pets.vue';
import PlanDetails from '../views/PlanDetails.vue';
import Plans from '../views/Plans.vue';
import PlanRanking from '../views/PlanRanking.vue';
import ContractRanking from '../views/ContractRanking.vue';
import ServiceRanking from '../views/ServiceRanking.vue';
import ContractProfitability from '../views/ContractProfitability.vue';
import CacCltv from '../views/CacCltv.vue';
import B2cCltv from '../views/B2cCltv.vue';
import MetricasMascotas from '../views/MetricasMascotas.vue';
import NewMrrReport from '../views/NewMrrReport.vue';
import Renovaciones from '../views/Renovaciones.vue';
import ContractSuccess from '../views/ContractSuccess.vue';
import Users from '../views/Users.vue';
import Companies from '../views/Companies.vue';
import ClientOrgCharts from '../views/ClientOrgCharts.vue';
import ClientOrgChartDetail from '../views/ClientOrgChartDetail.vue';
import ClientOrgChartUnassigned from '../views/ClientOrgChartUnassigned.vue';
import ServicesRecords from '../views/ServicesRecords.vue';
import RegisterRefund from '../views/RegisterRefund.vue';
import CreateUser from '../views/CreateUser.vue';
import ClinicOnboarding from '../views/ClinicOnboarding.vue';
import DroopyClinics from '../views/DroopyClinics.vue';
import DroopyClinicServices from '../views/DroopyClinicServices.vue';
import MRRDetalle from '../views/MrrDetalle.vue';
import MrrDaily from '../views/MrrDaily.vue';
import B2CReportV2 from '../views/B2CReportV2.vue';
import TipoCambio from '../views/TipoCambio.vue';
import AddPet from '../views/AddPet.vue';
import RefundView from '../views/RefundView.vue';
import RefundClinics from '../views/RefundClinics.vue';
import RefundRedirectProfiles from '../views/RefundRedirectProfiles.vue';
import Data from '../views/Data.vue';
import CompanyDetails from '../views/CompanyDetails.vue';
import Vision360 from '../views/Vision360.vue'
import Contratos from '../views/Contratos.vue'
import Productos from '../views/Productos.vue'
import LineasNegocio from '../views/LineasNegocio.vue'
import Brokers from '../views/Brokers.vue'
import RespuestasTipo from '../views/RespuestasTipo.vue'
import Servicios from '../views/Servicios.vue'
import Metas from '../views/Metas.vue'
import Ejecutivos from '../views/Ejecutivos.vue'
import BillingHistorial from '../views/BillingHistorial.vue'
import BillingIndividual from '../views/BillingIndividual.vue'
import BillingImportar from '../views/BillingImportar.vue'
import ShelterPets from '../views/ShelterPets.vue'
import MetricasCES from '../views/MetricasCES.vue'
import MetricasReembolsos from '../views/MetricasReembolsos.vue'
import MetricasPetmed from '../views/MetricasPetmed.vue'
import SponsorshipMetrics from '../views/SponsorshipMetrics.vue'
import ClubDescuentos from '../views/ClubDescuentos.vue'
import PosterAds from '../views/PosterAds.vue'
import CargasMasivas from '../views/CargasMasivas.vue'
import FullContractRenewal from '../views/FullContractRenewal.vue'
import CoTutores from '../views/CoTutores.vue'
import Vencimientos from '../views/Vencimientos.vue'
import OppositionRequests from '../views/OppositionRequests.vue'
import InternalTools from '../views/InternalTools.vue'
import TermsNotification from '../views/TermsNotification.vue'
import Profile from '../views/Profile.vue'
import AuthService from '../services/auth.service'
import { resolveLanding } from '../utils/nav-sections.utils'
import Cotizador from '../views/Cotizador.vue'
import Cotizaciones from '../views/Cotizaciones.vue'
import CotizacionDetalle from '../views/CotizacionDetalle.vue'
import AnalisisActuarial from '../views/AnalisisActuarial.vue';
import ClinicBilling from '../views/ClinicBilling.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // Top-level, outside the Home shell: these run on the enrollment token, which
  // Home's getUserData() guard would (correctly) reject.
  {
    path: '/mfa/setup',
    name: 'MfaSetup',
    component: MfaSetup
  },
  {
    path: '/mfa/verify',
    name: 'MfaVerify',
    component: MfaVerify
  },
  {
    path: '/',
    name: 'Usuarios',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '/profile',
        name: 'Perfil',
        component: Profile
      },
      {
        path: '/users',
        name: 'Users',
        component: Users
      },
      {
        path: '/users/create-user',
        name: 'Crear Usuario',
        component: CreateUser
      },
      {
        path: '/clinics/onboarding',
        name: 'Clínicas Droopy',
        component: ClinicOnboarding
      },
      {
        path: '/clinics/droopy',
        name: 'Droopy',
        component: DroopyClinics
      },
      {
        path: '/clinics/droopy/:clinicId/services',
        name: 'Servicios de clínica Droopy',
        component: DroopyClinicServices,
        props: true
      },
      {
        path: '/data',
        name: 'Users',
        component: Data
      },
      {
        path: '/siniestralidad',
        name: 'Siniestralidad',
        component: Users
      },
      {
        path: '/services',
        name: 'Uso de servicios',
        component: Users
      },
      {
        path: '/memberships',
        name: 'Companies',
        component: Memberships
      },
      {
        path: '/memberships/:userId',
        name: 'Memberships by User',
        component: Memberships
      },
      {
        path: '/my-downloads',
        name: 'MyDownloads',
        component: MyDownloads
      },
      {
        path: '/pets',
        name: 'Pets',
        component: Pets
      },
      {
        path: '/pets/:userId',
        name: 'Pets by User',
        component: Pets
      },
      {
        path: '/memberships/:userId/add',
        name: 'AddPet',
        component: AddPet,
        props: true
      },
      {
        path: '/dxp',
        name: 'Solicitud DxP',
        component: Pets
      },
      {
        path: '/sponsorships',
        name: 'Apadrinamiento',
        component: Pets
      },
      {
        path: '/sponsorships/shelter-pets',
        name: 'Mascotas Apadrinamiento',
        component: ShelterPets
      },
      {
        path: '/sponsorships/metricas',
        name: 'Métricas Apadrinamiento',
        component: SponsorshipMetrics
      },
      {
        path: '/business-relationships/plans',
        name: 'Plans',
        component: Plans
      },
      {
        path: '/business-relationships/plans/ranking',
        name: 'PlanRanking',
        component: PlanRanking
      },
      {
        path: '/contratos/ranking',
        name: 'ContractRanking',
        component: ContractRanking
      },
      {
        path: '/metricas/service-ranking',
        name: 'ServiceRanking',
        component: ServiceRanking
      },
      {
        path: '/metricas/contract-profitability',
        name: 'ContractProfitability',
        component: ContractProfitability
      },
      {
        path: '/metricas/cac-cltv',
        name: 'CacCltv',
        component: CacCltv
      },
      {
        path: '/metricas/b2c-cltv',
        name: 'B2cCltv',
        component: B2cCltv
      },
      {
        path: '/metricas/mascotas-protegidas',
        name: 'MetricasMascotas',
        component: MetricasMascotas
      },
      {
        path: '/metricas/contract-success',
        name: 'ContractSuccess',
        component: ContractSuccess
      },
      {
        path: '/metricas/new-mrr',
        name: 'NewMrrReport',
        component: NewMrrReport
      },
      {
        path: '/metricas/renovaciones',
        name: 'Renovaciones',
        component: Renovaciones
      },
      {
        path: '/business-relationships/plans/:planId',
        name: 'PlanDetails',
        component: PlanDetails,
        props: true
      },
      {
        path: '/business-relationships/companies',
        name: 'Empresas',
        component: Companies
      },
      {
        path: '/clients/org-charts',
        name: 'ClientOrgCharts',
        component: ClientOrgCharts
      },
      // Antes que la ruta con :pipedriveOrgId, para que "unassigned" no se lea como id.
      {
        path: '/clients/org-charts/unassigned',
        name: 'ClientOrgChartUnassigned',
        component: ClientOrgChartUnassigned
      },
      {
        path: '/clients/org-charts/:pipedriveOrgId',
        name: 'ClientOrgChartDetail',
        component: ClientOrgChartDetail
      },
      {
        path: '/opposition-requests',
        name: 'OppositionRequests',
        component: OppositionRequests
      },
      {
        path: '/terms-notification',
        name: 'TermsNotification',
        component: TermsNotification
      },
      {
        path: '/herramientas-internas/ranger-test-chat',
        name: 'Chat de prueba Ranger',
        component: InternalTools
      },
      {
        path: '/business-relationships/companies/:companyId',
        name: 'Empresas',
        component: CompanyDetails,
        props: true
      },
      {
        path: '/business-relationships/alliances',
        name: 'Club de Descuentos',
        component: ClubDescuentos
      },
      {
        path: '/business-relationships/poster-ads',
        name: 'Posters de beneficios',
        component: PosterAds
      },
      {
        // Vista "Resumen MRR" deprecada (2026-10-07): no tenía entrada en el menú y
        // duplicaba MRR Resumen. La URL vieja redirige para no romper marcadores.
        path: '/finances/mrr',
        redirect: '/finances/metas'
      },
      {
        path: '/finances/mrr-detalle',
        name: 'MRR Detalle',
        component: MRRDetalle
      },
      {
        path: '/finances/mrr-daily',
        name: 'MRR Daily',
        component: MrrDaily
      },
      {
        path: '/finances/b2c-report-v2',
        name: 'Reporte B2C v2',
        component: B2CReportV2
      },
      {
        path: '/finances/metas',
        name: 'Metas',
        component: Metas
      },
      {
        path: '/finances/tipo-cambio',
        name: 'Tasa de Cambio',
        component: TipoCambio
      },
      {
        path: '/finances/payments',
        name: 'Pagos recibidos',
        component: Payments
      },
      {
        path: '/registers/register-refunds',
        name: 'RegisterRefund',
        component: RegisterRefund
      },
      {
        path: '/registers/servicesrecords',
        name: 'Registro Servicios',
        component: ServicesRecords
      },
      {
        path: '/refunds/new',
        name: 'Refunds2',
        component: RefundView
      },
      {
        path: '/refunds/clinics',
        name: 'RefundClinics',
        component: RefundClinics
      },
      {
        path: '/refunds/redirect-profiles',
        name: 'RefundRedirectProfiles',
        component: RefundRedirectProfiles
      },
      {
        path: '/users/:pgId',
        name: 'Vision360',
        component: Vision360
      },
      {
        path: '/contratos',
        name: 'Contratos',
        component: Contratos
      },
      {
        path: '/vencimientos',
        name: 'Vencimientos',
        component: Vencimientos
      },
      {
        path: '/contratos/productos',
        name: 'Productos',
        component: Productos
      },
      {
        path: '/mantenedores/lineas-negocio',
        name: 'LineasNegocio',
        component: LineasNegocio
      },
      {
        path: '/configuracion/brokers',
        name: 'Brokers',
        component: Brokers
      },
      {
        path: '/mantenedores/respuestas-tipo',
        name: 'RespuestasTipo',
        component: RespuestasTipo
      },
      {
        path: '/mantenedores/servicios',
        name: 'Servicios',
        component: Servicios
      },
      {
        path: '/configuracion/ejecutivos',
        name: 'Administradores',
        component: Ejecutivos
      },
      {
        path: '/finances/billing/historial',
        name: 'BillingHistorial',
        component: BillingHistorial
      },
      {
        path: '/finances/billing/individual',
        name: 'BillingIndividual',
        component: BillingIndividual
      },
      {
        path: '/finances/billing/importar',
        name: 'BillingImportar',
        component: BillingImportar
      },
      {
        path: '/metricas/ces',
        name: 'Métricas CES',
        component: MetricasCES
      },
      {
        path: '/metricas/reembolsos',
        name: 'Métricas Reembolsos',
        component: MetricasReembolsos
      },
      {
        path: '/metricas/petmed',
        name: 'Métricas PetMed',
        component: MetricasPetmed
      },
      {
        path: '/cargas-masivas',
        name: 'Cargas Masivas',
        component: CargasMasivas
      },
      {
        path: '/renovacion-contrato',
        name: 'Renovación de Contrato',
        component: FullContractRenewal
      },
      {
        path: '/vetops/co-tutores',
        name: 'Co-tutores',
        component: CoTutores
      },
      {
        path: '/cotizador',
        name: 'Cotizador',
        component: Cotizador
      },
      {
        path: '/cotizador/:id',
        name: 'Editar cotización',
        component: Cotizador
      },
      {
        path: '/cotizaciones',
        name: 'Cotizaciones',
        component: Cotizaciones
      },
      {
        path: '/cotizaciones/:id',
        name: 'Detalle de cotización',
        component: CotizacionDetalle
      },
      {
        path: '/finanzas/analisis-actuarial',
        name: 'AnalisisActuarial',
        component: AnalisisActuarial
      },
      {
        path: '/finanzas/facturacion-clinicas',
        name: 'ClinicBilling',
        component: ClinicBilling
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Landing resolution (spec 028). Only the bare root `/` is resolved — login also
// lands there — so a deep link is never redirected. It cannot be a route
// `redirect`: redirects are resolved during matching, before any guard, and are
// synchronous, so they cannot wait for the admin's preference from /me.
router.beforeEach(async (to, from, next) => {
  if (to.path !== '/') return next();
  const res = await AuthService.getUserData();
  const preferences = res.status === 'ok' && res.data ? res.data.preferences : null;
  // On a failed /me the fallback still loads, and Home.vue's own check sends the
  // admin to /login or /mfa/setup exactly as before.
  next({ path: resolveLanding(preferences && preferences.defaultSection), replace: true });
});

// Google Analytics GA4 — registra cada cambio de sección
router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: to.name || to.path,
      page_path: to.path,
    });
  }
});

export default router;
